import { Box } from "lucide-react";

export default function EmptyCatalog({ title = "The first drop is loading.", text = "New pieces are being printed. Check back soon." }) {
  return (
    <div data-testid="empty-catalog" className="relative border border-white/10 bg-[#0a0a0c] py-24 px-6 flex flex-col items-center text-center overflow-hidden">
      <div className="hero-glow w-72 h-72 -top-24 left-1/2 -translate-x-1/2 opacity-40" />
      <div className="relative w-16 h-16 border border-white/15 flex items-center justify-center mb-8" style={{ transform: "rotate(45deg)" }}>
        <Box size={22} strokeWidth={1} className="text-white" style={{ transform: "rotate(-45deg)" }} />
      </div>
      <h3 className="relative font-display text-2xl sm:text-3xl font-bold tracking-tight uppercase text-white">{title}</h3>
      <p className="relative mt-3 text-sm text-zinc-400 max-w-sm">{text}</p>
      <div className="relative w-48 mt-8 overflow-hidden"><div className="print-line" /></div>
    </div>
  );
}
